// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/common.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/common.proto.
 */
export const file_nodebase_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * RequestMeta travels on requests for protocol versioning and optional
 * operation-specific idempotency.
 *
 * @generated from message nodebase.v1.RequestMeta
 */
export type RequestMeta = Message<"nodebase.v1.RequestMeta"> & {
  /**
   * Protocol major version, e.g. "v1".
   *
   * @generated from field: string protocol_version = 1;
   */
  protocolVersion: string;

  /**
   * Client-generated opaque ID reserved for RPCs that explicitly document
   * replay semantics. There is no implicit global dedupe guarantee.
   *
   * @generated from field: string request_id = 2;
   */
  requestId: string;
};

/**
 * Describes the message nodebase.v1.RequestMeta.
 * Use `create(RequestMetaSchema)` to create a new message.
 */
export const RequestMetaSchema: GenMessage<RequestMeta> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 0);

/**
 * ResponseMeta travels on responses so clients can detect version drift.
 *
 * @generated from message nodebase.v1.ResponseMeta
 */
export type ResponseMeta = Message<"nodebase.v1.ResponseMeta"> & {
  /**
   * Lowest client/agent version the server still accepts.
   *
   * @generated from field: string min_compat_version = 1;
   */
  minCompatVersion: string;
};

/**
 * Describes the message nodebase.v1.ResponseMeta.
 * Use `create(ResponseMetaSchema)` to create a new message.
 */
export const ResponseMetaSchema: GenMessage<ResponseMeta> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 1);

/**
 * WorkerProductContract is the stable product promise a Worker exposes to
 * people, AI tools, and the web console. Observed health and resource usage do
 * not belong here: those change moment to moment. This message only carries
 * behavior a user may safely build work around.
 *
 * @generated from message nodebase.v1.WorkerProductContract
 */
export type WorkerProductContract = Message<"nodebase.v1.WorkerProductContract"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: nodebase.v1.WorkerDataPolicy data = 2;
   */
  data?: WorkerDataPolicy | undefined;

  /**
   * @generated from field: nodebase.v1.WorkerStableCapabilities capabilities = 3;
   */
  capabilities?: WorkerStableCapabilities | undefined;
};

/**
 * Describes the message nodebase.v1.WorkerProductContract.
 * Use `create(WorkerProductContractSchema)` to create a new message.
 */
export const WorkerProductContractSchema: GenMessage<WorkerProductContract> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 2);

/**
 * WorkerDataPolicy separates persistence, storage protection, and backup.
 * They are different promises: an encrypted persistent Home is not, by itself,
 * a recoverable backup.
 *
 * @generated from message nodebase.v1.WorkerDataPolicy
 */
export type WorkerDataPolicy = Message<"nodebase.v1.WorkerDataPolicy"> & {
  /**
   * @generated from field: bool home_persistent = 1;
   */
  homePersistent: boolean;

  /**
   * @generated from field: bool home_restored_on_rebuild = 2;
   */
  homeRestoredOnRebuild: boolean;

  /**
   * @generated from field: nodebase.v1.WorkerStorageProtection storage_protection = 3;
   */
  storageProtection: WorkerStorageProtection;

  /**
   * independent_backup is the platform-backup promise evaluated from facts,
   * not a flag flipped once at delivery: an off-host copy no older than the
   * RPO, a valid and current integrity check, and a restore drill within the
   * last 30 days (worker-evolution-plan §3). Any of the three lapsing turns
   * it false again. The readings behind it travel in WorkerBackupStatus,
   * outside this contract, because they change day to day.
   *
   * @generated from field: bool independent_backup = 4;
   */
  independentBackup: boolean;
};

/**
 * Describes the message nodebase.v1.WorkerDataPolicy.
 * Use `create(WorkerDataPolicySchema)` to create a new message.
 */
export const WorkerDataPolicySchema: GenMessage<WorkerDataPolicy> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 3);

/**
 * WorkerBackupStatus carries the platform-backup facts behind
 * WorkerDataPolicy.independent_backup so a user can see why it is what it
 * is. Reported by the host-side backup job through Control; the Worker never
 * grades its own backup. Unix seconds; zero means never. It describes the
 * platform copy only — a user-owned backup is a different product and gets
 * its own status when it ships.
 *
 * @generated from message nodebase.v1.WorkerBackupStatus
 */
export type WorkerBackupStatus = Message<"nodebase.v1.WorkerBackupStatus"> & {
  /**
   * The freshness bound the platform commits to for this Worker.
   *
   * @generated from field: int64 rpo_seconds = 1;
   */
  rpoSeconds: bigint;

  /**
   * @generated from field: int64 latest_success_unix = 2;
   */
  latestSuccessUnix: bigint;

  /**
   * @generated from field: int64 latest_integrity_check_unix = 3;
   */
  latestIntegrityCheckUnix: bigint;

  /**
   * @generated from field: bool latest_integrity_valid = 4;
   */
  latestIntegrityValid: boolean;

  /**
   * @generated from field: int64 restore_drill_unix = 5;
   */
  restoreDrillUnix: bigint;

  /**
   * The evaluated verdict, identical to WorkerDataPolicy.independent_backup.
   *
   * @generated from field: bool independent_backup = 6;
   */
  independentBackup: boolean;

  /**
   * Why the verdict is false; empty when it is true.
   *
   * @generated from field: string reason = 7;
   */
  reason: string;

  /**
   * Operator label for the destination (e.g. "r2:platform-backup"). Never a
   * credential or a full path.
   *
   * @generated from field: string destination = 8;
   */
  destination: string;
};

/**
 * Describes the message nodebase.v1.WorkerBackupStatus.
 * Use `create(WorkerBackupStatusSchema)` to create a new message.
 */
export const WorkerBackupStatusSchema: GenMessage<WorkerBackupStatus> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 4);

/**
 * WorkerStableCapabilities is the cross-surface capability vocabulary. True
 * and false are both product facts: an AI must be able to plan around an absent
 * capability before it fails halfway through a task.
 *
 * @generated from message nodebase.v1.WorkerStableCapabilities
 */
export type WorkerStableCapabilities = Message<"nodebase.v1.WorkerStableCapabilities"> & {
  /**
   * @generated from field: bool ssh = 1;
   */
  ssh: boolean;

  /**
   * @generated from field: bool private_network = 2;
   */
  privateNetwork: boolean;

  /**
   * @generated from field: bool managed_services = 3;
   */
  managedServices: boolean;

  /**
   * @generated from field: bool managed_cron = 4;
   */
  managedCron: boolean;

  /**
   * @generated from field: bool managed_secrets = 5;
   */
  managedSecrets: boolean;

  /**
   * @generated from field: bool private_web = 6;
   */
  privateWeb: boolean;

  /**
   * @generated from field: bool snapshots = 7;
   */
  snapshots: boolean;

  /**
   * @generated from field: bool root = 8;
   */
  root: boolean;

  /**
   * @generated from field: bool sudo = 9;
   */
  sudo: boolean;

  /**
   * @generated from field: bool docker = 10;
   */
  docker: boolean;

  /**
   * @generated from field: bool public_ports = 11;
   */
  publicPorts: boolean;

  /**
   * @generated from field: bool continues_when_device_disconnects = 12;
   */
  continuesWhenDeviceDisconnects: boolean;

  /**
   * @generated from field: bool public_web = 13;
   */
  publicWeb: boolean;
};

/**
 * Describes the message nodebase.v1.WorkerStableCapabilities.
 * Use `create(WorkerStableCapabilitiesSchema)` to create a new message.
 */
export const WorkerStableCapabilitiesSchema: GenMessage<WorkerStableCapabilities> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 5);

/**
 * PathTelemetry is durable latest state, not an event stream. Counters let an
 * operator distinguish endpoint churn from user-visible reconnects without
 * storing a device's historical network trajectory.
 *
 * @generated from message nodebase.v1.PathTelemetry
 */
export type PathTelemetry = Message<"nodebase.v1.PathTelemetry"> & {
  /**
   * @generated from field: uint64 rotations_total = 1;
   */
  rotationsTotal: bigint;

  /**
   * @generated from field: uint64 reconnects_total = 2;
   */
  reconnectsTotal: bigint;

  /**
   * @generated from field: nodebase.v1.PathTransitionReason last_reason = 3;
   */
  lastReason: PathTransitionReason;

  /**
   * @generated from field: int64 last_transition_unix = 4;
   */
  lastTransitionUnix: bigint;
};

/**
 * Describes the message nodebase.v1.PathTelemetry.
 * Use `create(PathTelemetrySchema)` to create a new message.
 */
export const PathTelemetrySchema: GenMessage<PathTelemetry> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 6);

/**
 * PageRequest is a forward-only cursor page.
 *
 * @generated from message nodebase.v1.PageRequest
 */
export type PageRequest = Message<"nodebase.v1.PageRequest"> & {
  /**
   * @generated from field: string after_cursor = 1;
   */
  afterCursor: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message nodebase.v1.PageRequest.
 * Use `create(PageRequestSchema)` to create a new message.
 */
export const PageRequestSchema: GenMessage<PageRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 7);

/**
 * PageResponse carries the next cursor; empty when the page is exhausted.
 *
 * @generated from message nodebase.v1.PageResponse
 */
export type PageResponse = Message<"nodebase.v1.PageResponse"> & {
  /**
   * @generated from field: string next_cursor = 1;
   */
  nextCursor: string;
};

/**
 * Describes the message nodebase.v1.PageResponse.
 * Use `create(PageResponseSchema)` to create a new message.
 */
export const PageResponseSchema: GenMessage<PageResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_common, 8);

/**
 * ErrorCode mirrors the domain error / CLI exit codes (technical plan §4.4).
 *
 * @generated from enum nodebase.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_USER = 2;
   */
  USER = 2,

  /**
   * @generated from enum value: ERROR_CODE_PERMISSION = 3;
   */
  PERMISSION = 3,

  /**
   * @generated from enum value: ERROR_CODE_QUOTA = 4;
   */
  QUOTA = 4,

  /**
   * @generated from enum value: ERROR_CODE_PLATFORM = 5;
   */
  PLATFORM = 5,

  /**
   * @generated from enum value: ERROR_CODE_INCOMPATIBLE = 6;
   */
  INCOMPATIBLE = 6,
}

/**
 * Describes the enum nodebase.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_common, 0);

/**
 * WorkerStorageProtection is reported from the Control-owned storage format,
 * never guessed from inside the container. UNSPECIFIED means the authority did
 * not report a protection state; consumers must not render it as encrypted.
 *
 * @generated from enum nodebase.v1.WorkerStorageProtection
 */
export enum WorkerStorageProtection {
  /**
   * @generated from enum value: WORKER_STORAGE_PROTECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Persistent host storage without a per-Worker encryption claim. Retained
   * for rollback/dev truth; it must not be described as encrypted at rest.
   *
   * @generated from enum value: WORKER_STORAGE_PROTECTION_LEGACY_HOST_STORAGE = 1;
   */
  LEGACY_HOST_STORAGE = 1,

  /**
   * The selected Home generation is encrypted at rest with a distinct
   * per-Worker data-encryption key.
   *
   * @generated from enum value: WORKER_STORAGE_PROTECTION_PER_WORKER_ENCRYPTED = 2;
   */
  PER_WORKER_ENCRYPTED = 2,
}

/**
 * Describes the enum nodebase.v1.WorkerStorageProtection.
 */
export const WorkerStorageProtectionSchema: GenEnum<WorkerStorageProtection> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_common, 1);

/**
 * PathTransitionReason separates why the selected data-plane endpoint moved
 * from whether the product actually reconnected. It is intentionally small
 * and stable so latest-state diagnostics never become a per-request history.
 *
 * It answers two questions that are the same fact seen from two sides: why a
 * device moved, and why it is where it is rather than on the candidate the
 * control plane ranked first (PathDeviation, network.proto). Giving those two
 * separate vocabularies would mean translating between them to read a single
 * causal chain — which is how a dispatch that never took effect was read as a
 * dispatch that did. Values 8+ exist only for the second question: a device can
 * sit off rank 0 without ever having transitioned.
 *
 * Readers must not hard-code the upper bound. One did, and it would have
 * clamped every value added here to UNSPECIFIED — a normal-looking wrong
 * result, which is the failure class this repository pays the most for.
 *
 * @generated from enum nodebase.v1.PathTransitionReason
 */
export enum PathTransitionReason {
  /**
   * @generated from enum value: PATH_TRANSITION_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_HANDSHAKE_STALE = 1;
   */
  HANDSHAKE_STALE = 1,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_INBAND_DATA_FAILED = 2;
   */
  INBAND_DATA_FAILED = 2,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_SHAPED = 3;
   */
  SHAPED = 3,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_UDP_RECOVERY = 4;
   */
  UDP_RECOVERY = 4,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_PROBATION_ROLLBACK = 5;
   */
  PROBATION_ROLLBACK = 5,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_RELAY_RECOVERY = 6;
   */
  RELAY_RECOVERY = 6,

  /**
   * @generated from enum value: PATH_TRANSITION_REASON_CONFIG_CHANGED = 7;
   */
  CONFIG_CHANGED = 7,

  /**
   * The escape hold that moved this device off its ranked candidate has not
   * expired yet. Deliberately distinct from SHAPED: that names the observation,
   * this names the timer still holding the device away from rank 0.
   *
   * @generated from enum value: PATH_TRANSITION_REASON_ESCAPE_HOLD_ACTIVE = 8;
   */
  ESCAPE_HOLD_ACTIVE = 8,

  /**
   * Rank 0 had no *usable* carrier credential at decision time.
   *
   * Usable, not unexpired — the distinction is load-bearing. Admission is the
   * Gateway's call: it accepts an otherwise valid ticket for a bounded window
   * past expiry on a new handshake, so a device can legitimately be carrying
   * traffic on an expired ticket. A client that treats "expired" as "unusable"
   * is executing an admission decision that is not its own, and the two sides
   * then disagree about the same state — the exact misreading this vocabulary
   * exists to prevent. The client's job is to prefer the freshest credential,
   * not to refuse on the Gateway's behalf.
   *
   * @generated from enum value: PATH_TRANSITION_REASON_CREDENTIAL_EXPIRED = 9;
   */
  CREDENTIAL_EXPIRED = 9,

  /**
   * The user pinned this candidate. Explicit intent, not a fallback.
   *
   * @generated from enum value: PATH_TRANSITION_REASON_USER_PINNED = 10;
   */
  USER_PINNED = 10,
}

/**
 * Describes the enum nodebase.v1.PathTransitionReason.
 */
export const PathTransitionReasonSchema: GenEnum<PathTransitionReason> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_common, 2);

